<!-- @format -->

<template>
	<layout-default-new>
		<div v-if="loading">Loading.....</div>
		<div>Getting Order Report please wait....</div>
	</layout-default-new>
</template>

<script>
import { useQuery, useResult } from '@vue/apollo-composable'
import { onMounted, reactive } from '@vue/composition-api'
import Store from '@/store'
import Router from '@/router'
import storeOrder from '@/_srcv2/pages/order/_shared/useOrderState.js'

import GetOrderReportDataQuery from '@/_srcv2/pages/order/_shared/get-order-report/graphql/GetOrderReportDataQuery.graphql'

export default {
	name: 'GetOrderReport',
	setup() {
		const { reportOurCompany, reportOrderNumber } = storeOrder()
		// get order report info
		const options = reactive({
			fetchPolicy: 'no-cache',
		})
		const { result, refetch, loading } = useQuery(
			GetOrderReportDataQuery,
			() => ({
				company_id: reportOurCompany.value,
				order_number: reportOrderNumber.value,
			}),
			options,
		)
		// ****************************************************************************************************
		const getReportData = (data) => {
			return new Promise((resolve, reject) => {
				if (data !== null || undefined) {
					const allReportDataForOrder = useResult(
						result,
						null,
						(data) => data.order_headers,
					)
					console.log('allReportDataForOrder', allReportDataForOrder)
					resolve(allReportDataForOrder.value[0])
				} else {
					const reason = new Error('Data could not be fetched from database')
					reject(reason)
				}
			})
		}
		const storeReportData = (data) => {
			return new Promise((resolve, reject) => {
				if (data !== null || undefined) {
					Store.dispatch('setOrderReportData', data).then(() => {
						if (Store.getters.getOrderReportData !== undefined) {
							console.log('')
							Router.push({ name: 'OrderReportPdf' })
							resolve(true)
						}
					})
				} else {
					const reason = new Error('Data can not be stored')
					reject(reason)
				}
			})
		}
		// ----------------------------------------------------------------------------
		const a = () => {
			getReportData(result).then((data) => {
				storeReportData(data)
			})
		}
		console.log('GetOrderReport created is fired')
		onMounted(() => {
			console.log('GetOrderReport onMounted is fired')
			refetch().then(() => a())
		})
		return {
			loading,
		}
	},
}
</script>

<style scoped>
.margin-top-25 {
	margin-top: 25px;
}
</style>
